export enum EnumModalQueueItemType {
  Recruit = 'congratulate-recruit',
  Init = 'congratulate-init',
  Exit = 'topic-exit',
  Gift = 'common-gift',
  Coupon = 'order-coupon-gift'
}

export enum EnumRegisterModalNames {
  Topic = 'topic-modal',
  Gift = 'common-gift-modal',
  Coupon = 'order-coupon-gift-modal'
}

export enum EnumModalQueueItemCode {
  Recruit = 50100,
  Init = 50101,
  Exit = 50102,
  Gift = 10326,
  Coupon = 10803
}
